import React from "react";
import { Reveal, SectionHeading } from "@/components/common";
import { FAQS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQSection = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-20 sm:py-28 bg-[#f7faf8]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading overline="FAQ" title="Questions, answered." center />
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
            {FAQS.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-slate-100 bg-white px-5 soft-shadow"
              >
                <AccordionTrigger className="text-left text-[#091630] font-bold hover:no-underline hover:text-[#16a34a] py-5">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-500 text-[15px] leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQSection;
